import React from 'react';
import PostAddLayout from 'components/layout/PostAddLayout/PostAddLayout';

const AddPostPage = () => (
  <>
    <PostAddLayout />
  </>
);

export default AddPostPage;
